import { Accordion, AccordionSummary, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  Box,
  Paper,
  IconButton,
  Typography,
  Grid,
  TextField,
  InputLabel,
  Badge,
  FormControlLabel,
  Radio,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import "@fontsource/manrope";
import { colors } from "@zapalacorp/tokens";
import RadioButton from "Components/Form/RadioGroup";
import { AvatarGeneric } from "Components/Generic/SettingsUserForm/components/AvatarGeneric";

export const StyledRadioBox = styled(Box, { shouldForwardProp: (prop) => prop !== "isSelected" })<{
  isSelected?: boolean;
}>(({ theme, isSelected }) => ({
  border: `2px solid ${isSelected ? "#004D95" : "#E4E7EC"}`,
  padding: theme.spacing(1),
  fontFamily: "Manrope !important",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  transition: "border-color 0.3s",
  marginTop: "10px",
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  width: "100%",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0),
  fontFamily: "Manrope !important",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  color: "#475467",
}));

export const StyledGridContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& [class^="makeStyles-label"]': {
    color: "#004D95 !important",
  },
}));
export const CustomRadio = styled(Radio)(() => ({
  color: "#E4E7EC",
  "&.Mui-checked": {
    color: "#004D95",
  },
}));

export const StyledGridItem = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const StyledInputLabel = styled(InputLabel)(() => ({
  color: "#004D95",
}));

export const CircleBadge = styled(Badge)(({ theme }) => ({
  ".MuiBadge-dot": {
    borderRadius: "50%",
    width: 24,
    height: 24,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<{ isSelected?: boolean; label?: string }>(({ isSelected }) => ({
  "& .MuiFormControlLabel-label": {
    color: isSelected ? "#004D95" : "#475467",
    transition: "color 0.3s",
    fontFamily: "Manrope, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "22px",
    display: "flex",
    alignItems: "center",
  },
}));

const styles = makeStyles(() => ({
  equipment_input: {
    backgroundColor: "red",
  },
}));

export default styles;

export const SectionTitle = styled(Typography)(() => ({
  textAlign: "left",
  marginLeft: "-20px",
  color: "#475467",
  fontFamily: "Manrope !important",
  fontSize: "16px  !important",
  fontWeight: "600 !important",
  letterSpacing: "0.15px",
}));
export const SectionTitleGeneral = styled(Typography)(() => ({
  textAlign: "left",
  marginLeft: "0px",
  color: "#475467",
  fontFamily: "Manrope !important",
  fontSize: "16px  !important",
  fontWeight: "600 !important",
  letterSpacing: "0.15px",
}));

export const FileInputBox = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "10px",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: 250,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(5),
  marginTop: theme.spacing(2),
  backgroundImage:
    "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23333' stroke-width='2' stroke-dasharray='19, 18' stroke-dashoffset='29' stroke-linecap='square'/%3e%3c/svg%3e\")",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  cursor: "pointer",
  position: "relative",
}));

export const FileInputText = styled(Typography)(() => ({
  textAlign: "center",
  color: "#465869",
  fontFamily: "Manrope !important",
  fontWeight: "600",
  fontSize: "18px",
  marginBottom: 0,
}));

export const FileInputSubText = styled(Typography)(() => ({
  textAlign: "center",
  color: "#667085",
  fontFamily: "Manrope !important",
  fontWeight: "400",
  fontSize: "14px",
  marginBottom: 0,
}));

export const IconSectionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "80%",
  borderRadius: theme.shape.borderRadius,
}));

export const IconGrid = styled(Grid)(() => ({
  display: "flex",
}));

export const StyledTextNoData = styled("div")(() => ({
  color: "var(--Neutral-Gray-600, #475467)",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "32px",
  marginBottom: "15px",
}));

export const Circle = styled("div")<{ borderColor: string }>(({ borderColor }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 30,
  height: 30,
  borderRadius: "50%",
  border: `2px solid ${borderColor}`,
  color: borderColor,
  fontWeight: "bold",
  fontSize: 16,
  marginRight: 20,
}));

export const StyledH1 = styled("h1")(() => ({
  fontFamily: "Manrope, sans-serif",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
}));

export const ImageBox = styled(Box)(() => ({
  maxHeight: "250px",
  maxWidth: "210px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const LeftPanelContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(2),
}));

export const Imagecontiner = styled(Box)(() => ({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "cover",
}));

export const SelectIconImage = styled("img")<{ selected?: boolean }>(({ selected }) => ({
  cursor: "pointer",
  width: "80%",
  height: "auto",
  border: selected ? "2px solid #004D95" : "none",
  transition: "border 0.2s ease",
  position: "relative",
}));

export const IconOverlay = styled(IconButton)({
  position: "absolute",
  top: "0px",
  right: "5px",
  color: "#ffffff",
  backgroundColor: "#039855",
  borderRadius: "50%",
  height: "24px",
  width: "24px",
  "& svg": {
    fontSize: "16px",
  },
});

export const BadgeContainer = styled(Box)<{
  backgroundColor: string;
  borderRadius: string;
  padding: string;
}>(({ backgroundColor, borderRadius, padding }) => ({
  backgroundColor,
  borderRadius,
  padding,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const BadgeText = styled(Typography)<{
  textColor: string;
  textSize: string;
  fontWeight: number;
}>(({ textColor, textSize, fontWeight }) => ({
  color: textColor,
  fontSize: textSize,
  fontWeight,
}));

export const MemberTypographyBody = styled(Typography)(() => ({
  fontSize: "16px",
  fontFamily: "Manrope",
  fontWeight: 400,
  color: "var(--Neutral-Gray-600, #475467)",
  lineHeight: "24px",
  margin: 0,
}));

export const MemberTypography = styled(Typography)(() => ({
  color: "var(--Neutral-Gray-600, #475467)",
  fontFamily: "Manrope",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
}));
export const MemberContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(2),
}));
export const MemberImageBox = styled(Box)(() => ({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "cover",
}));

export const UserCardContainer = styled(Box)(() => ({
  border: "2px solid #E6EEF6",
  borderRadius: "4px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px",
}));
export const TypographyEmail = styled(Typography)(() => ({
  fontFamily: "Manrope, sans-serif",
  color: "#475467",
  fontSize: "16px !important",
  fontWeight: "400!important",
  lineHeight: "24px!important",
}));

export const TypographyName = styled(Typography)(() => ({
  fontFamily: "Manrope, sans-serif",
  color: "#475467",
  fontSize: "28px !important",
  fontWeight: "500!important",
  lineHeight: "26px!important",
}));

export const TypographyRole = styled(Typography)(() => ({
  fontFamily: "Manrope, sans-serif",
  color: "#475467",
  fontSize: "12px !important",
  fontWeight: "700 !important",
  lineHeight: "16px!important",
}));

export const UserCardInnerContainer = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(5),
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
}));
export const BodyContainer = styled(Box)(() => ({
  maxWidth: "1600px",
  zIndex: 10,
  backgroundColor: "#F9FAFB !important",
  minHeight: "1220px",
  width: "100vw",
  padding: "5% 10%",
}));
export const CircleNumberBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
}));
export const CheckBoxContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginLeft: theme.spacing(2),
  display: "flex",
}));
export const BoxContainer = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  bgcolor: "white",
  width: "100%",
  padding: theme.spacing(2, 3),
  height: "72px",
  border: "1px solid #E4E7EC",
  backgroundColor: "#ffffff !important",
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "flex-end",
}));
export const StyledGrid = styled(Grid)({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "10px",
});
export const AccordionBody = styled(Accordion)(() => ({
  boxShadow: "none !important",
  border: "1px solid #D0D5DD !important",
}));

export const AccordionSummaryStyled = styled(AccordionSummary)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const BadgeContainerBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));
export const CancelButton = styled(Button)(() => ({
  color: "#000000 !important",
  marginRight: "5px !important",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
}));
export const OutlineButton = styled(Button)(() => ({
  marginRight: "5px !important",
  color: "#12B76A !important",
  borderColor: "#12B76A",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
}));

export const CreateButton = styled(Button)(() => ({
  marginRight: "5px !important",
  backgroundColor: "#12B76A !important",
  color: "#ffffff !important",
  "&.MuiButton-root": {
    textTransform: "none !important",
  },
}));

export const ButtonStack = styled(Stack)(() => ({
  spacing: 2,
  height: "35px",
  flexDirection: "row",
  "& .cancelBtn": {
    color: "#000000 !important",
  },
}));

export const CustomRadioButton = styled(RadioButton)(() => ({
  "& .MuiFormControlLabel-label": {
    color: `${colors.gray600} !important`,
    textAlign: "center",
    fontFamily: "Manrope !important",
    fontSize: "22px !important",
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    lineHeight: "28px !important",
  },
}));

export const SimpleText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",

  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const CustomAvatarGeneric = styled(AvatarGeneric)(() => ({
  width: "100%",
}));
